import qs from 'qs';

export type IParams = {
  [key: string]:
    | string
    | number
    | boolean
    | string[]
    | number[]
    | boolean[]
    | IParams;
};

export default function paramsSerializer<T extends IParams>(params: T) {
  return qs.stringify(params, {
    arrayFormat: 'repeat',
    skipNulls: true,
    encode: true,
    format: 'RFC3986',
    allowDots: true,
  });
}
